__turbopack_context__.v({
  "error-card": "ErrorCard-module-scss-module__ICc-vq__error-card",
  "error-card__content": "ErrorCard-module-scss-module__ICc-vq__error-card__content",
  "error-card__cta": "ErrorCard-module-scss-module__ICc-vq__error-card__cta",
  "error-card__heading": "ErrorCard-module-scss-module__ICc-vq__error-card__heading",
  "error-card__icon": "ErrorCard-module-scss-module__ICc-vq__error-card__icon",
});
